import { apiSlice } from "../api/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: () => "/assignmentMark",
    }),
    getAssignmentMark: builder.query({
      query: ({ student_id, assignment_id }) =>
        `/assignmentMark?student_id=${student_id}&assignment_id=${assignment_id}`,
    }),
    createAssignmentMark: builder.mutation({
      query: (data) => ({
        url: "/assignmentMark",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.data?.id) {
            // passimistically update the assignmentMarks
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignmentMarks",
                undefined,
                (draft) => {
                  draft.push(result.data);
                }
              )
            );

            // passimistically update the assignmentMark
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignmentMark",
                { student_id: result.data.student_id, assignment_id: result.data.assignment_id },
                (draft) => {
                  draft.push(result.data);
                }
              )
            );

          }
        } catch (err) {
          console.log(err);
        }
      }
    }),
    updateAssignmentMark: builder.mutation({
      query: (data) => ({
        url: `/assignmentMark/${data.id}?assignment_id=${data.assignment_id}&student_id=${data.student_id}`,
        method: "PATCH",
        body: data.assignment,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;

          if (result.data) {
            console.log(result.data);
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignmentMarks",
                undefined,
                (draft) => {
                  const assignmentMark = draft.find(
                    (assignmentMark) =>
                      assignmentMark.student_id === result.data.student_id &&
                      assignmentMark.assignment_id === result.data.assignment_id
                  );

                  assignmentMark.mark = result.data.mark;
                  assignmentMark.status = result.data.status;
                }
              )
            );
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    deleteAssignmentMark: builder.mutation({
      query: (assignmentMarkId) => ({
        url: `/assignmentMark/${assignmentMarkId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAssignmentMarksQuery,
  useGetAssignmentMarkQuery,
  useCreateAssignmentMarkMutation,
  useUpdateAssignmentMarkMutation,
  useDeleteAssignmentMarkMutation,
} = assignmentMarkApi;
